import client from "@https/api";
import type { IHomeDataInput } from "@types";
import gate from "gate/gate";

const homeApi = {
  getData: () =>
    gate.get<IHomeDataInput, never, never>({
      client,
      url: `homepage`,
    }),
};

export default homeApi;
